import axios from "axios";
import { getLocalStorage } from "../helpers/storage";

//import { API_ENDPOINT } from "../configs";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
const api = axios.create({
  baseURL: API_ENDPOINT,
});


// If token is expired
/*
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;
    if (error.response.status === 402 && !originalRequest.retry) {
      originalRequest.retry = true;
      const tokens = JSON.parse(localStorage.getItem("tokens"));
      return api
        .post("auth/refreshToken", { refreshToken: tokens.refreshToken })
        .then(({ data }) => {
          tokens.accessToken = data.accessToken;
          tokens.refreshToken = data.refreshToken;
          localStorage.setItem("tokens", JSON.stringify(tokens));
          originalRequest.headers.Authorization = `Bearer ${tokens.accessToken}`;
          originalRequest.headers["x-access-token"] = tokens.accessToken;
          return axios(originalRequest);
        });
    }
    return Promise.reject(error);
  }
);
*/

const getOptions = () => {
  
  const token = getLocalStorage("token");
  if (token) {
    return {
      "Content-Type": "application/x-www-form-urlencoded",
      headers: {
        Authorization: `token ${token}`,
        Accept: "application/json, application/x-www-form-urlencoded",
      },
    };
  }
  else {
    return {"Content-Type": "application/x-www-form-urlencoded"};
  }
};

const errorResponse = (error) => {
  const response = new Error(error.response.data.error);
  throw response;
};

export const eliminate = async (url, params = {}, headers = {}) => {
  try {
    const options = { ...getOptions(), ...headers };
    const { data } = await api.delete(url, params, options);
    return data;
  } catch (error) {
    throw errorResponse(error);
  }
};

export const put = async (url, params = {}, headers = {}) => {
  try {
    const options = { ...getOptions(), ...headers };
    const { data } = await api.put(url, params, options);
    return data;
  } catch (error) {
    throw errorResponse(error);
  }
};

export const post = async (url, params = {}, headers = {}) => {
  try {
    const options = { ...getOptions(), ...headers };
    const { data } = await api.post(url, params, options);
    return data;
  } catch (error) {
    throw errorResponse(error);
  }
};

export const get = async (url, headers = {}, params = {}) => {
  try {
    const options = { ...getOptions(), ...headers, params: params };
    const { data } = await api.get(url, options);
    return data;
  } catch (error) {
    throw errorResponse(error);
  }
};

export const getImage = async (url, headers = {}) => {
  try {
    const options = { ...getOptions(), ...headers, responseType: "blob" };
    const { data } = await api.get(url, options);
    return data;
  } catch (error) {
    throw errorResponse(error);
  }
};